import { Helmet } from "react-helmet-async";
import AboutContent from "../../components/about/aboutContent/AboutContent.tsx";
import Banner from "../../components/banner/Banner.tsx";

const About = () => {
  return (
    <div>
        {/* SEO */}
      <Helmet>
        <title>À propos de nous - VRN Innovation</title>
        <meta
          name="description"
          content="VRN Innovation, entreprise basée à Douala, Cameroun, spécialisée en développement web et mobile, réseaux, domotique, Starlink, sécurité et consulting IT. Découvrez notre expertise et nos valeurs."
        />
        <meta
          name="keywords"
          content="À propos VRN Innovation, entreprise IT Douala, développement web Cameroun, mobile, réseaux, domotique, Starlink, cybersécurité, consulting IT"
        />
        <link rel="canonical" href="https://www.vrn-innovation.com/about" />
      </Helmet>
      <Banner
        title="A propos"
        breadcrumbs={[
          { label: "Accueil", link: "/" },
          { label: "A propos" },
        ]}
      />
      <AboutContent />
    </div>
  );
};

export default About;
